import axios from 'axios';
import {
    DOCTOR_PAYOUT_LIST_REQUEST,
    DOCTOR_PAYOUT_LIST_SUCCESS,
    DOCTOR_PAYOUT_LIST_FAIL,
    DOCTOR_PAYOUT_CREATE_REQUEST,
    DOCTOR_PAYOUT_CREATE_SUCCESS,
    DOCTOR_PAYOUT_CREATE_FAIL,
    DOCTOR_PAYOUT_UPDATE_REQUEST,
    DOCTOR_PAYOUT_UPDATE_SUCCESS,
    DOCTOR_PAYOUT_UPDATE_FAIL,
    baseURL
} from './types';

const API_BASE_URL = `${baseURL}/api/appointementDoctorPayoutRecord`;

/**
 * Fetches all doctor payout records for the logged-in doctor.
 */
export const listDoctorPayouts = () => async (dispatch) => {
    try {
        dispatch({ type: DOCTOR_PAYOUT_LIST_REQUEST });

        const token = localStorage.getItem("token");
        const hospitalID = localStorage.getItem('hospitalCode');
        
        if (!token || !hospitalID) {
            throw new Error('Not authorized or essential user data (hospitalID) is missing.');
        }

        const config = {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        };

        const filterPayload = { hospitalID };
        const { data: responseData } = await axios.post(`${API_BASE_URL}/getall`, filterPayload, config);

        if (responseData && Array.isArray(responseData.data)) {
            dispatch({ type: DOCTOR_PAYOUT_LIST_SUCCESS, payload: responseData.data });
        } else {
            console.error("API response for payout records is not in the expected array format:", responseData);
            dispatch({ type: DOCTOR_PAYOUT_LIST_SUCCESS, payload: [] });
        }
    } catch (error) {
        dispatch({
            type: DOCTOR_PAYOUT_LIST_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};



export const listAllDoctorPayoutsForAdmin = () => async (dispatch) => {
    try {
        dispatch({ type: DOCTOR_PAYOUT_LIST_REQUEST });

        const token = localStorage.getItem("token"); // Admins also need to be authenticated
        if (!token) {
            throw new Error('Not authorized, no token found.');
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        };

        // ✅ THE FIX: Send an EMPTY payload. This tells the backend "no filters, give me everything".
        // This assumes your backend API is designed to return all records when the body is empty.
        const filterPayload = {}; 
        const { data: responseData } = await axios.post(`${API_BASE_URL}/getall`, filterPayload, config);

        if (responseData && Array.isArray(responseData.data)) {
            dispatch({
                type: DOCTOR_PAYOUT_LIST_SUCCESS,
                payload: responseData.data,
            });
        } else {
            console.error("API response for admin payout records is not in the expected array format:", responseData);
            dispatch({ type: DOCTOR_PAYOUT_LIST_SUCCESS, payload: [] });
        }
    } catch (error) {
        dispatch({
            type: DOCTOR_PAYOUT_LIST_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};
/**
 * Creates a new doctor payout record.
 */
export const createDoctorPayoutRecord = (payoutData) => async (dispatch) => {
    try {
        dispatch({ type: DOCTOR_PAYOUT_CREATE_REQUEST });
        
        const token = localStorage.getItem("token");
        if (!token) throw new Error('Not authorized, no token found.');

        const config = {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        };

        const createResponse = await axios.post(`${API_BASE_URL}/create`, payoutData, config);

        if (createResponse.status === 201) {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const hospitalID = localStorage.getItem('hospitalCode');
            if (!hospitalID) throw new Error("Could not refresh list: hospitalID not found in localStorage.");
            
            const filterPayload = { hospitalID };
            const { data: responseData } = await axios.post(`${API_BASE_URL}/getall`, filterPayload, config);
            const allRecords = responseData.data;

            if (!Array.isArray(allRecords)) {
                throw new Error("Could not refresh payout list: API response was not an array.");
            }
            
            const newRecord = allRecords.find(
                (record) => String(record.invoiceId || record.InvoiceId) === String(payoutData.invoiceId)
            );

            if (newRecord) {
                dispatch({ type: DOCTOR_PAYOUT_CREATE_SUCCESS, payload: newRecord });
                return Promise.resolve(newRecord);
            } else {
                throw new Error('Record was created, but could not be found in the refreshed list.');
            }
        } else {
            throw new Error(`Server responded with status ${createResponse.status}`);
        }

    } catch (error) {
        const errorMessage = error.response?.data?.message || error.message;
        dispatch({ type: DOCTOR_PAYOUT_CREATE_FAIL, payload: errorMessage });
        return Promise.reject(new Error(errorMessage));
    }
};

/**
 * Updates an existing doctor payout record.
 */
export const updateDoctorPayoutRecord = (id, payoutDataToUpdate) => async (dispatch) => {
    try {
        dispatch({ type: DOCTOR_PAYOUT_UPDATE_REQUEST });

        const token = localStorage.getItem("token");
        if (!token) throw new Error('Not authorized, no token found.');

        const config = {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        };

        const updatePayload = {
            id: id,
            ...payoutDataToUpdate,
        };

        const { data } = await axios.patch(`${API_BASE_URL}/update`, updatePayload, config);

        dispatch({
            type: DOCTOR_PAYOUT_UPDATE_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: DOCTOR_PAYOUT_UPDATE_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};